import { hexToRgbArr } from '@/themes/colorUtils/colorUtils';
import themeInterface from '@/themes/themes/themeInterface';

const createRgbVars = (obj) => Object.entries(obj).reduce((prev, [key, value]) => {
  const themeItem = {
    ...prev,
  };

  if ((typeof value === 'string' || value instanceof String)) {
    if (value.startsWith('#')) {
      themeItem[key] = {
        hex: value,
        rgb: hexToRgbArr(value).join(', '),
      };
    } else if (value.startsWith('var') && value.endsWith('hex')) {
      themeItem[key] = {
        hex: value,
        rgb: value.replace('hex', 'rgb'),
      };
    } else {
      themeItem[key] = value;
    }
  } else if (value && typeof value === 'object' && value.constructor === Object) {
    themeItem[key] = createRgbVars(value);
  }

  return themeItem;
}, {});

class Theme {
  constructor(options = themeInterface, isDark = false) {
    this.isDark = isDark;

    Object.assign(this, {
      ...options,
      ...createRgbVars(options),
    });
  }
}

export default Theme;
